import { useId } from "react";

import { IconClose } from "@/shared/icons";

import {
  Canvas,
  CanvasContainer,
  ClearButton,
  Label,
  SignatureContainer,
} from "./SignaturePad.styles";
import { useSignatureCanvas } from "./hooks/useSignatureCanvas";

export interface SignaturePadProps {
  readonly onChange: (file: File | null) => void;
  readonly disabled?: boolean;
  /** True while drawing or exporting the latest stroke. */
  readonly onCaptureBusyChange?: (busy: boolean) => void;
}

export const SignaturePad = ({
  onChange,
  disabled = false,
  onCaptureBusyChange,
}: SignaturePadProps) => {
  const labelId = useId();
  const { canvasRef, hasSignature, clearSignature } = useSignatureCanvas({
    onChange,
    disabled,
    onCaptureBusyChange,
  });

  return (
    <SignatureContainer role="group" aria-labelledby={labelId}>
      <Label id={labelId}>Firma manuscrita digitalizada</Label>

      <CanvasContainer $disabled={disabled}>
        <Canvas
          ref={canvasRef}
          $disabled={disabled}
          role="img"
          aria-label="Área para dibujar la firma"
        />

        {hasSignature && (
          <ClearButton
            type="button"
            onClick={clearSignature}
            disabled={disabled}
            aria-label="Borrar firma"
          >
            <IconClose width={18} height={18} color="#437084" />
          </ClearButton>
        )}
      </CanvasContainer>
    </SignatureContainer>
  );
};
